/**
 * CheckboxFilter
 * @description Filter an array of items based on query field
 * @author Martin Hansen <martin.hansen@valtech.com>
 */

import debounce from 'lodash.debounce';

export class CheckboxFilter {
    constructor (element) {
        element.CheckboxFilter = this;

        this._refs = {
            element: element,
            toolbar: element.querySelector('.checkbox-filter__toolbar'),
            query: element.querySelector('.checkbox-filter__query'),
            items: element.querySelector('.checkbox-filter__items') 
        };

        this._props = {};

        // Check if more than 3 items are available, if not turn off element
        if (this.items.length < 3) {
            return false;
        } 
        
        // # UI
        this._refs.element.classList.add('is-visible');
        
        // # Events
        if(this._refs.query) {
            this._refs.query.addEventListener('keyup', debounce(this._onKeyUp.bind(this), 30));
            this._refs.query.addEventListener('keydown', this._onKeyDown.bind(this));
        }
    }

    /**
     * @description Key prevention
     * @param {Event} e - Event interface 
     */
    _onKeyDown (e)  {
        if(e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    }

    /**
     * @description Eventhandler for manipulating list of items
     * @param {Event} e - Event Interface 
     */
    _onKeyUp (e) {
        const value = e.target.value.toLowerCase();

        if(!value.length) {
            this.items.forEach(x => x.el.classList.remove('is-hidden'));
            return false
        }

        this.items.forEach(x => x.value.toLowerCase().indexOf(value) !== -1 ? x.el.classList.remove('is-hidden') : x.el.classList.add('is-hidden'));
    }

    /**
     * @description Get all items in a predefined template
     * @returns {Array} Output - Array of Item Objects
     */
    get items () {
        let output = [];
        
        if(this._refs.items.children == null || !this._refs.items.children.length) return output;

        Array.from(this._refs.items.children).forEach(x => output.push({ el: x, value: x.innerText.replace(/,/g,'').trim().toLowerCase(), visible: !x.classList.contains('is-hidden') }));

        return output;
    }
}